<template>
  <div>
    <section class="section">
      <div id="top"></div>
      <!-- 検索コンポーネント -->
      <searchComponet @getSearch="getSearch($event)" :daterange="daterange" :isToggleActive="isToggleActive"></searchComponet>
      <table class="table is-fullwidth is-bordered">
        <thead>
          <tr>
            <th>TaskNo.</th>
            <th>件名</th>
            <th>登録日</th>
            <th>緊急性</th>
            <template v-if="modules.module_mode">
              <th>モード</th>
            </template>
            <th>ステータス</th>
            <th>登録者</th>
            <th>担当</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in taskListData" :key="index">
            <th>{{item.id}}</th>
            <td>
                <a v-bind:href="'/#/task/edit/'+item.id" v-tooltip="shortMsg(item.comment, 100)">{{item.task_title}}</a>
            </td>
            <td>{{item.created_at}}</td>
            <td>{{item.urgency_name}}</td>
            <template v-if="modules.module_mode">
              <td v-if="item.fk_mode == 1">通常モード</td>
              <td v-if="item.fk_mode == 2" class="has-text-danger">災害モード</td>
            </template>
            <td>{{item.status_name}}</td>
            <td>{{item.register_name}}</td>
            <td>{{item.rep_name}}</td>
            <td>
              <span class="icon">
                <a v-bind:href="'/#/task/edit/'+item.id">
                  <i class="fas fa-edit"></i>
                </a>
              </span>
              <span class="icon">
                <a v-bind:href="'/#/task/report/'+item.id" target="_blank">
                  <i class="fas fa-file-pdf is-hidden-touch"></i>
                </a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <InfiniteLoading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more">No more task</div>
        <div slot="no-results">検索結果がありません</div>
      </InfiniteLoading>
      <transition name="fade">
        <a href="#" v-scroll-to="'#top'" class="scroll-top" v-show="isScrollShow">
          <i class="fa fa-angle-up fa-lg scroll-top__ico"></i>
        </a>
      </transition>
    </section>
  </div>
</template>

<script>
import search_componet from '../../components/search_menu_head'
import moment from 'moment'
import InfiniteLoading from 'vue-infinite-loading'
import { mapState } from 'vuex'

export default {
  data:function(){
    return {
      search_params:{
        fk_urgency: '',
        fk_status_id: '',
        fk_mode: '',
        fk_register_id: '',
        fk_rep_id: '',
      },
      daterange:{
        to: '',
        from: '',
      },
      limit: 25,
      page:1,
      isToggleActive: true,
      infiniteId: +new Date(),
      scrollY: 0,
    }
  },
  components: {
    InfiniteLoading,
    'searchComponet': search_componet,
  },
  mounted() {
    this.$store.dispatch('task/clearTasks')
    let today = moment().format("YYYY-MM-DD");
    this.daterange.from = moment(today).add(-1, 'M').format("YYYY-MM-DD");  //1ヶ月前からデータに絞り込み
    this.daterange.to = today
    // スクロールを取得
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("load", () => {
      this.onScroll();
    });
  },
  computed: {
    ...mapState({
      complete: state => state.task.complete,
      modules: state => state.auth.modules,
      taskListData: state => state.task.tasks,
      apiStatus: state => state.task.apiStatus,
      errorMessages: state => state.task.errorMessages
    }),
    isScrollShow() {
      return this.scrollY > 200 ? true : false;
    },
  },
  methods:{
    // スクロール値の取得
    onScroll() {
      this.scrollY = window.pageYOffset;
    },
    getSearch(eventArgs){
      this.$store.dispatch('task/clearTasks')
      this.search_params = eventArgs[0]
      this.daterange = eventArgs[1]
      this.page = 1
      this.infiniteId += 1
    },
    async infiniteHandler($state){
      if (this.loading) return; // 読み込み中ならスキップ
      this.loading = true;
      this.$set(this, 'isToggleActive', true)
      await this.$store.dispatch('task/getTaskList',
        {
          search_params: this.search_params,
          daterange: this.daterange,
          limit: this.limit,
          page: this.page,
        },
      )
      if(this.apiStatus){
        this.loading = false;
        this.$set(this, 'isToggleActive', false)
        if(this.complete) {
          $state.complete()
          return
        }
        this.page += 1
        $state.loaded()
      }
    },
    shortMsg(strMsg, sliceNum){
      if(strMsg.length > sliceNum){
        return strMsg.slice(0, sliceNum) + '....'
      }
      return strMsg
    }
  }
}
</script>

<style lang="scss">
.scroll-top {
  position: fixed;
  bottom: 32px;
  right: 32px;
  background-color: #000;
  padding: 10px 16px;
  border-radius: 32px;
  &__ico {
    font-weight: bold;
    font-size: 20px;
    color: #fff;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>